import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Login from './pages/Login';
import AppShell from './components/shell/AppShell';
import { SIGNED_IN_ROUTES } from './routes';

// MGMT-PANEL-BUILD-SHELL-01: every signed-in route renders inside one AppShell layout route
// (sidebar, header, padding, footer). The route list itself moved unchanged to src/routes.js.
// The login page stays outside the shell, in the same full-height frame it had before.
const App = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const auth = getAuth();
        // Listen for authentication state changes
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setIsAuthenticated(true);
            } else {
                setIsAuthenticated(false);
                // Redirect to login if not authenticated and not already on the login page
                if (location.pathname !== '/login') {
                    navigate('/login');
                }
            }
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, [navigate, location.pathname]);

    const handleLogout = () => {
        getAuth().signOut();  // Log the user out
        navigate('/login'); // Redirect to login page
    };

    return (
        <Routes>
            <Route
                path="/login"
                element={
                    <Box
                        component="main"
                        sx={{ flexGrow: 1, height: '100vh', overflowY: 'auto', overflowX: 'hidden', backgroundColor: 'var(--bg)', display: 'flex', flexDirection: 'column', position: 'relative' }}
                    >
                        <Login />
                    </Box>
                }
            />

            {isAuthenticated && (
                <Route element={<AppShell handleLogout={handleLogout} />}>
                    {SIGNED_IN_ROUTES.map(({ path, element }) => (
                        <Route key={path} path={path} element={element} />
                    ))}
                    {/* Unknown paths keep the sidebar and an empty page, as before; the shell logs [SHELL_NO_TITLE]. */}
                    <Route path="*" element={null} />
                </Route>
            )}
        </Routes>
    );
}

export default App;
